module.exports = __webpack_public_path__ + "img/beecoins.df36f5d9.png";